import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import PropTypes from "prop-types";
import * as stylex from '@stylexjs/stylex';
export default function Text(props) {
  var _finalString, _props$title;
  var style = {};
  var finalString = props.children;
  var originalString = (_finalString = finalString) === null || _finalString === void 0 ? void 0 : _finalString.toString().trim();
  if (props.size) {
    style.fontSize = "".concat(props.size, "px");
  }
  if (props.color) {
    style.color = props.color;
  }
  if (props.lineHeight) {
    style.lineHeight = "".concat(props.lineHeight, "px");
  }
  if (props.truncateAt) {
    finalString = props.children.toString().trim().substring(0, props.truncateAt);
    if (props.showTruncateEllipsis === void 0 || props.showTruncateEllipsis) {
      finalString += "...";
    }
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    title: (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : props.truncateAt ? originalString : undefined
  }, stylex.props(ui.base, props.bold && ui.bold, props.secondary && ui.secondary, props.smallcaps && ui.smallcaps, props.center && ui.center, props.monospace && ui.monospace, props.useAlternateTypeface && ui.font_2, props.italic && ui.italic, props.stylex), {
    style: _objectSpread(_objectSpread({}, style), props.style)
  }), finalString);
}
Text.propTypes = {
  size: PropTypes.number,
  bold: PropTypes.bool,
  secondary: PropTypes.bool,
  color: PropTypes.string,
  lineHeight: PropTypes.number,
  smallcaps: PropTypes.bool,
  center: PropTypes.bool
};
Text.defaultProps = {
  bold: false,
  secondary: false,
  smallcaps: false
};

// @ts-ignore
_inject(".evr0sq7q{color:var(--shade-80)}", 3000);
_inject(".ev1xlr1w8{font-weight:700}", 3000);
_inject(".ev1blgh98{color:var(--shade-40)}", 3000);
_inject(".evtvhhri{text-transform:uppercase}", 3000);
_inject(".ev2b8uid{text-align:center}", 3000);
_inject(".ev1lliihq{display:block}", 3000);
_inject(".ev1v65pqg{font-family:mononoki,\"Souce Code Pro\",consolas,monospace}", 3000);
_inject(".evdmev4j{font-family:font2}", 3000);
_inject(".ev1k4tb9n{font-style:italic}", 3000);
var ui = {
  base: {
    "Text__ui.base": "Text__ui.base",
    color: "evr0sq7q",
    $$css: true
  },
  bold: {
    "Text__ui.bold": "Text__ui.bold",
    fontWeight: "ev1xlr1w8",
    $$css: true
  },
  secondary: {
    "Text__ui.secondary": "Text__ui.secondary",
    color: "ev1blgh98",
    $$css: true
  },
  smallcaps: {
    "Text__ui.smallcaps": "Text__ui.smallcaps",
    textTransform: "evtvhhri",
    $$css: true
  },
  center: {
    "Text__ui.center": "Text__ui.center",
    textAlign: "ev2b8uid",
    display: "ev1lliihq",
    $$css: true
  },
  monospace: {
    "Text__ui.monospace": "Text__ui.monospace",
    fontFamily: "ev1v65pqg",
    $$css: true
  },
  font_2: {
    "Text__ui.font_2": "Text__ui.font_2",
    fontFamily: "evdmev4j",
    $$css: true
  },
  italic: {
    "Text__ui.italic": "Text__ui.italic",
    fontStyle: "ev1k4tb9n",
    $$css: true
  }
};